import {API_BASE_URL} from "./constants";
import {secureFetch} from "./authService";

export function getLoanSummaryProps(retailerId) {
    let url = API_BASE_URL + `/loan/property/summary?retailerId=${retailerId}`;

    return secureFetch(url, {
        method: 'GET',
    });
}


// WEBPACK FOOTER //
// ./src/helpers/loanSummaryPropertyService.js